import { render } from "./PeopleEntryView.vue?vue&type=template&id=218a0e76"
import script from "./PeopleEntryView.vue?vue&type=script&lang=js"
export * from "./PeopleEntryView.vue?vue&type=script&lang=js"
script.render = render

export default script